import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { LegalSeo } from '../seo/PageSeo';
import { homePath } from '../seo/seoConfig';

export default function LegalPage({ pageKey }) {
  const { t } = useTranslation();
  const { lang } = useParams();
  const sections = t(`legal.${pageKey}.sections`, { returnObjects: true });
  const intro = pageKey === 'privacy' ? t('legal.privacy.intro') : null;

  useEffect(() => { window.scrollTo(0, 0); }, [pageKey, lang]);

  return (
    <main className="min-h-screen bg-gradient-to-b from-gray-50 to-white dark:from-slate-950 dark:to-slate-900" data-testid={`legal-page-${pageKey}`}>
      <LegalSeo lang={lang} pageKey={pageKey} />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-20">
        <Link to={homePath(lang)} className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-blue-600 mb-6" data-testid="legal-back-home">
          <ArrowLeft className="h-3 w-3" /> {t('nav.home')}
        </Link>
        <h1 className="text-[2rem] leading-tight sm:text-5xl font-bold text-gray-900 dark:text-white mb-6 break-words" data-testid="legal-h1">{t(`legal.${pageKey}.h1`)}</h1>
        {intro && <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed mb-10">{intro}</p>}
        <div className="space-y-8">
          {sections.map((s) => (
            <section key={s.title}>
              <h2 className="text-base md:text-lg font-semibold text-gray-900 dark:text-white mb-3">{s.title}</h2>
              {s.paragraphs.map((p) => (
                <p key={p} className="text-gray-600 dark:text-gray-300 leading-relaxed whitespace-pre-line mb-3">{p}</p>
              ))}
            </section>
          ))}
        </div>
      </article>
    </main>
  );
}
